export const PrivateChatInactive = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M11.6666 5.33333V4.66667C11.6666 3.42899 11.1749 2.242 10.2998 1.36684C9.42458 0.491665 8.2376 0 6.99992 0C5.76224 0 4.57526 0.491665 3.70009 1.36684C2.82492 2.242 2.33325 3.42899 2.33325 4.66667V5.33333H0.333252V14C0.333252 14.5304 0.543966 15.0391 0.919038 15.4142C1.29411 15.7893 1.80282 16 2.33325 16H11.6666C12.197 16 12.7057 15.7893 13.0808 15.4142C13.4559 15.0391 13.6666 14.5304 13.6666 14V5.33333H11.6666ZM7.66659 12H6.33325V9.33333H7.66659V12ZM10.3333 5.33333H3.66659V4.66667C3.66659 3.78261 4.01777 2.93477 4.6429 2.30964C5.26802 1.68452 6.11586 1.33333 6.99992 1.33333C7.88397 1.33333 8.73182 1.68452 9.35694 2.30964C9.98206 2.93477 10.3333 3.78261 10.3333 4.66667V5.33333Z"
      fill="url(#paint0_linear_3894_16821)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3894_16821"
        x1="6.99992"
        y1="0"
        x2="6.99992"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C0BBCF" />
        <stop offset="1" stopColor="#968FA9" />
      </linearGradient>
    </defs>
  </svg>
);
